module.exports = __webpack_public_path__ + "img/itx-file-type-xlsx.dbc46d09.svg";